import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../theme';

export const useRoutingsFilterStyles = createStyles(({ token }) => ({
  routingsFilterCol: {
    border: `0.8px solid ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY8_7, 0.95)}`,
  },

  quoteRoutingsFilter: {
    '&&': {
      '.MonitorSearchFilters-CurrentState': {
        paddingLeft: ThemeSpaces.SPACE_NORM0_5,
        backgroundColor: token.colorWhite,
      },
      'h4.ant-typography': {
        fontSize: token.fontSizeLG,
      },
    },
  },

  directDriveCol: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    fontFamily: ThemeFont.FONT_CONDENSED,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 700,

    '&& .ant-form-item': {
      marginLeft: ThemeSpaces.SPACE_NORM0_5,
    },
  },

  usedFilterLabel: {
    color: token.colorPrimary,
    fontWeight: 700,
    marginLeft: ThemeSpaces.SPACE_NORM0_5,
  },

  directDriveTooltip: {
    '&& .ant-tooltip-inner': {
      lineHeight: '22px',
    },
  },
}));
